

export default function NewsAndSupplierSection() {
  return (
    <>
      {/* News + Intro split */}
      <section className="w-full bg-white py-20 px-6 md:px-16">
        <div className="max-w-7xl mx-auto">
          <span className="text-emerald-600 text-xs font-bold uppercase tracking-widest">Our Commitment</span>
          <h2
            className="text-3xl md:text-4xl font-extrabold text-stone-800 mt-3 mb-6"
            style={{ fontFamily: "'DM Serif Display', serif" }}
          >
            Quality, Compliance &amp; Confidentiality
          </h2>
          <div className="flex flex-col lg:flex-row gap-10">
            <div className="lg:w-1/2 flex flex-col gap-5 text-gray-600 text-base leading-relaxed">
              <p>
                As an experienced supplier, we select facilities and services that will meet the necessary
                compliance requirements of the mandate. Product specifications are clearly identified and
                adhered to on every delivery. Our infrastructure and services include access controlled,
                climate controlled (temperature) warehousing and the highest quality in logistics and
                movement of goods to ensure product traceability and integrity.
              </p>

              <p>
                Our drive and ambition is to deliver maximal value to our clients and suppliers. We accomplish
                this by facilitating and managing requirements under confidence and aligning these with quality
                sourcing options.
              </p>
            </div>
            <div className="lg:w-1/2 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-1 xl:grid-cols-3 gap-4 content-start">
              {[
                { icon: 'ri-shield-check-line', label: 'Compliance' },
                { icon: 'ri-lock-line', label: 'Confidential' },
              ].map((item) => (
                <div key={item.label} className="bg-stone-50 rounded-lg p-5 border border-stone-100">
                  <div className="w-10 h-10 flex items-center justify-center text-emerald-600 mb-3">
                    <i className={`${item.icon} text-2xl`} />
                  </div>
                  <div className="font-bold text-stone-800 text-sm">{item.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>


    </>
  );
}
